import React from "react";
import FullRouter from "./RouterPath/index";
import "bootstrap/dist/css/bootstrap.min.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./App.css";
import "./Assets/style/style.css";
import SessionTimeoutProvider from "./Pages/SessionTimeoutProvider";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { PermissionProvider } from "./Context/PermissionContext";
import { GoogleOAuthProvider } from "@react-oauth/google";

// Back Up
// const GOOGLE_CLIENT_ID = "311155435979-7vf3url3bjk2nthhrgia7skdiv7f4v1j.apps.googleusercontent.com";
const GOOGLE_CLIENT_ID = "393877425666-o8ddqc94htm7q047r1m8j06n3v62v2m3.apps.googleusercontent.com";

const theme = createTheme();

function App() {
  return (
    <HelmetProvider>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <PermissionProvider>
              <SessionTimeoutProvider>
                <FullRouter />
              </SessionTimeoutProvider>
            </PermissionProvider>
          </BrowserRouter>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </HelmetProvider>
  );
}

export default App;
